import { Link } from 'react-router';
import { alpha, styled } from '@mui/material';
import { common, grey } from '@mui/material/colors';

export const HeaderRoot = styled('div')({
  position: 'relative',
  zIndex: 1100,
  height: '2.5rem',
  padding: '0 1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  boxShadow: `0 0.2rem 0.4rem -0.1rem ${alpha(common.black, 0.33)}`,
  backgroundColor: grey[100],
});

export const HeaderLeftBlock = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

export const HomeLink = styled(Link)({
  color: 'inherit',
  textDecoration: 'none',
});
